import React from 'react';
import {IBoardSummary} from "../../ModelContracts";
import {Alert, Badge, Card, ListGroup, Stack} from "../ui";
import {Link} from "react-router-dom";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

interface IProps {
	boards: Array<IBoardSummary>
}

function CompletedBoardList({boards}: IProps) {
	return (
		<Card className="summary-lists" aria-label="Recently Onboarded">
			<Card.Body>
				<Stack direction="vertical" className="items-center" gap={2}>
					<h4>Recently Onboarded</h4>
					<ListGroup className="w-full">
						{
							boards.slice(0, 2).map((board: IBoardSummary) => (
								<ListGroup.Item
									key={board.id}
									role="listitem"
									aria-label={board.name}
									className="p-0">
									<Link
										to={`/boards/${board.id}`}
										className="flex justify-between items-center text-base-content py-2 px-4"
										aria-label={board.name}>
										<p className="m-0">{board.name}</p>
										<Badge
											pill
											bg="success"
											title={`Completed: ${dayjs(board.completedDate).format('Do MMMM YYYY')}`}>
											{dayjs(board.completedDate).format('Do MMM YY')}
										</Badge>
									</Link>
								</ListGroup.Item>
							))
						}
						{
							!boards.length &&
							<Alert variant="secondary">No customers have been onboarded yet</Alert>
						}
					</ListGroup>
				</Stack>
			</Card.Body>
		</Card>
	);
}

export default CompletedBoardList;
